import type * as stripeJs from '@stripe/stripe-js'
import { colors } from '@unocss/preset-mini/colors'
import { isClient } from '@vueuse/core'

export const isDarkMode = () => isClient && window.document.documentElement.classList.contains('dark-mode')

export default defineAppConfig({
  stripe: {
    elements: {
      options: {
        fonts: [
          {
            family: 'Fellix',
            weight: '400',
            display: 'swap',
            src: 'url(/fonts/fellix-400.woff2)',
          },
          {
            family: 'Fellix',
            weight: '600',
            display: 'swap',
            src: 'url(/fonts/fellix-600.woff2)',
          },
          {
            family: 'Fellix',
            weight: '700',
            display: 'swap',
            src: 'url(/fonts/fellix-7000.woff2)',
          },
        ],
      },
    },

    card: {
      // hidePostalCode: true,
      classes: {
        base: '',
        complete: '',
        empty: '',
        focus: '',
        invalid: '',
        webkitAutofill: '',
      },
      style: {
        base: {
          'backgroundColor': 'transparent',
          'color': isDarkMode() ? colors.slate[700] : colors.slate[900],
          'fontFamily': 'Fellix,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
          'fontSize': '16px',
          // 'fontSize': '32px',
          'fontSmoothing': 'antialiased',
          'lineHeight': '20px',
          //
          'iconColor': isDarkMode() ? colors.slate[400] : colors.slate[500],
          //
          ':hover': {},
          ':focus': {
            color: isDarkMode() ? colors.slate[700] : colors.slate[900],
          },
          '::placeholder': {
            color: isDarkMode() ? colors.slate[400] : colors.slate[500],
          },
          '::selection': {},
          ':-webkit-autofill': {},
          ':disabled': {
            color: colors.slate[500],
          },
        },
        complete: {},
        empty: {},
        invalid: {
          'iconColor': isDarkMode() ? colors.red[400] : colors.rose[400],
          'color': isDarkMode() ? colors.rose[200] : colors.red[900],
          '::placeholder': {
            color: isDarkMode() ? colors.red[400] : colors.rose[400],
          },
        },
      },
    } satisfies stripeJs.StripeCardElementOptions,

    p24Bank: {
      style: {
        base: {
          'color': isDarkMode() ? colors.slate[700] : colors.slate[900],
          'fontFamily': 'Fellix,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
          'fontSize': '16px',
          'fontSmoothing': 'antialiased',
          'padding': '8px',
          ':hover': {
            color: isDarkMode() ? colors.slate[700] : colors.slate[900],
          },
          ':focus': {
            color: isDarkMode() ? colors.slate[700] : colors.slate[900],
          },
          '::placeholder': {
            color: isDarkMode() ? colors.slate[400] : colors.slate[500],
          },
          ':disabled': {
            color: colors.slate[500],
          },
        },
        complete: {
          color: isDarkMode() ? colors.slate[700] : colors.slate[900],
          iconColor: isDarkMode() ? colors.slate[400] : colors.slate[500],
        },
        invalid: {
          'iconColor': isDarkMode() ? colors.red[400] : colors.rose[400],
          'color': isDarkMode() ? colors.rose[200] : colors.red[900],
          '::placeholder': {
            color: isDarkMode() ? colors.red[400] : colors.rose[400],
          },
        },
      },
      classes: {
        base: '',
        complete: '',
        empty: '',
        focus: '',
        invalid: '',
      },
    } as stripeJs.StripeP24BankElementOptions,
  },

  epsBank: {
    style: {
      base: {
        'color': isDarkMode() ? colors.slate[700] : colors.slate[900],
        'fontFamily': 'Fellix,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
        'fontSize': '16px',
        'fontSmoothing': 'antialiased',
        'padding': '12px',
        'lineHeight': '24px',
        ':hover': {
          color: isDarkMode() ? colors.slate[700] : colors.slate[900],
        },
        ':focus': {
          color: isDarkMode() ? colors.slate[700] : colors.slate[900],
        },
        '::placeholder': {
          color: isDarkMode() ? colors.slate[400] : colors.slate[500],
        },
        ':disabled': {
          color: colors.slate[500],
        },
      },
      complete: {
        color: isDarkMode() ? colors.slate[700] : colors.slate[900],
        iconColor: isDarkMode() ? colors.slate[400] : colors.slate[500],
      },
      invalid: {
        'iconColor': isDarkMode() ? colors.red[400] : colors.rose[400],
        'color': isDarkMode() ? colors.rose[200] : colors.red[900],
        '::placeholder': {
          color: isDarkMode() ? colors.red[400] : colors.rose[400],
        },
      },
    },
    classes: {
      base: '',
      complete: '',
      empty: '',
      focus: '',
      invalid: '',
    },
  } as stripeJs.StripeEpsBankElementOptions,

  ui: {
    input: {
      slots: {
        root: 'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent text-base file:text-base sm:(text-sm file:text-sm) file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      },
    },
  },
})
